import { ExportButtonDropdown, ExportType } from '@components'

import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'

import { useSegment } from '../../../../hooks'
import { ExportsCard } from '../ExportsCard'

const CHART_OF_ACCOUNTS_EXPORT_URL = 'chartOfAccounts'

export const ChartOfAccounts = () => {
  const { t } = useTranslation()
  const { downloadExportFile } = useDownloadExportFile()
  const { track } = useSegment()

  const handleSelect = useCallback(
    (_: string, type: ExportType) => {
      downloadExportFile({
        exportUrl: CHART_OF_ACCOUNTS_EXPORT_URL,
        type,
      })

      track('XXX - Mikkel - Exports', {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        export_type: 'Chart of accounts',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        file_format: type,
      })
    },
    [downloadExportFile, track],
  )

  return (
    <ExportsCard
      description={t('exports.card.chart_of_accounts.description')}
      title={t('exports.card.chart_of_accounts.title')}
      actionButton={
        <ExportButtonDropdown
          exportTypesToSkip={[ExportType.RegnskabBasis, ExportType.Html]}
          onSelect={handleSelect}
          variant="outlined"
          fullWidth
        />
      }
    />
  )
}
